import { Record } from "immutable";

import "seneca-common/features/course/state/models/state/courses/course/subscriptionTier/SubscriptionTier";

import { SubscriptionTier } from "seneca-common/features/course/state/models/state/courses/course/subscriptionTier/SubscriptionTier";

export type CourseEnrollmentType = {
  courseId: string;
  timeEnrolled: string;
  subscriptionTier: SubscriptionTier | null;
};

export type OptionalCourseEnrollmentType = Partial<CourseEnrollmentType>;

const defaultCourseEnrollment: CourseEnrollmentType = {
  courseId: "",
  timeEnrolled: "",
  subscriptionTier: null
};

export default class CourseEnrollment extends Record(defaultCourseEnrollment) {}
